<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="editMode ? $t('organization_profile.edit_organization_modal.edit_title') : $t('organization_profile.edit_organization_modal.create_title')"
    class="create-edit-modal"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <api-errors :errors="errors" />
      <el-form class="create-edit-form" :model="form" :rules="rules" ref="form" @change.native="onFormChange">
        <!-- <upload
          :label="$t('organization_profile.edit_organization_modal.upload_logo_field.label')"
          @uploadAvatar="handleAvatarUpload"
          class="square"
        /> -->
        <div class="form-row">
          <elsa-input
            name="name"
            :label="$t('organization_profile.edit_organization_modal.name_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.name_field.placeholder')"
            v-model.lazy="form.name"
          >
            {{ $t('organization_profile.edit_organization_modal.name_field.label') }}
          </elsa-input>
          <!-- <elsa-input
            name="username"
            :label="$t('organization_profile.edit_organization_modal.username_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.username_field.placeholder')"
            v-model.lazy="form.username"
          >
            {{ $t('organization_profile.edit_organization_modal.username_field.label') }}
          </elsa-input> -->
        </div>
        <div class="form-row">
          <elsa-select
            name="industry"
            :label="$t('organization_profile.edit_organization_modal.industry_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.industry_field.placeholder')"
            :options="industriesOptions"
            @change="onFormChange"
            filterable
            v-model.lazy="form.industry"
          />
          <elsa-select
            name="orgType"
            :label="$t('organization_profile.edit_organization_modal.org_type_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.org_type_field.placeholder')"
            :options="$store.state.organization.types"
            no-data-text="No organization types available"
            @change="onFormChange"
            v-model.lazy="form.orgType"
          />
        </div>
        <div class="form-row single address-row">
          <elsa-input
            name="address1"
            :label="$t('organization_profile.edit_organization_modal.address_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.address_field.placeholder')"
            v-model.lazy="form.address1"
          >
            {{ $t('organization_profile.edit_organization_modal.address_field.label') }}
          </elsa-input>
          <elsa-input
            name="address2"
            v-model.lazy="form.address2"
          >
          </elsa-input>
        </div>
        <div class="form-row">
          <elsa-input
            name="city"
            :label="$t('organization_profile.edit_organization_modal.city_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.city_field.placeholder')"
            v-model.lazy="form.city"
          >
            {{ $t('organization_profile.edit_organization_modal.city_field.label') }}
          </elsa-input>
          <elsa-input
            name="state"
            :label="$t('organization_profile.edit_organization_modal.state_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.state_field.placeholder')"
            v-model.lazy="form.state"
          >
            {{ $t('organization_profile.edit_organization_modal.state_field.label') }}
          </elsa-input>
          <elsa-input
            name="postcode"
            type="number"
            :label="$t('organization_profile.edit_organization_modal.post_code_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.post_code_field.placeholder')"
            v-model.lazy="form.postcode"
          >
            {{ $t('organization_profile.edit_organization_modal.post_code_field.label') }}
          </elsa-input>
        </div>
        <div class="form-row">
          <country-select
            name="country"
            :label="$t('organization_profile.edit_organization_modal.country_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.country_field.placeholder')"
            v-model="form.country"
            filterable
            @change="onFormChange"
          />
          <div class="phone-wrapper">
            <country-select
              name="phoneCode"
              :placeholder="$t('organization_profile.edit_organization_modal.code')"
              v-model="form.phoneCode"
              type="phone"
              filterable
              @change="onFormChange"
            />
            <elsa-input
              :label="$t('organization_profile.edit_organization_modal.phone_field.label')"
              name="phone"
              type="number"
              :placeholder="$t('organization_profile.edit_organization_modal.phone_field.placeholder')"
              v-model.lazy="form.phoneNumber"
            >
              {{ $t('organization_profile.edit_organization_modal.phone_field.label') }}
            </elsa-input>
          </div>
        </div>
        <div class="form-row">
          <elsa-select
            name="timezone"
            :label="$t('organization_profile.edit_organization_modal.timezone_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.timezone_field.placeholder')"
            :options="timezones"
            filterable
            :information="$t('organization_profile.edit_organization_modal.timezone_field.tooltip_create')"
            v-model.lazy="form.timezone"
          />
          <elsa-input
            name="code"
            :label="$t('organization_profile.edit_organization_modal.code_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.code_field.placeholder')"
            v-model.lazy="form.code"
          >
            {{ $t('organization_profile.edit_organization_modal.name_field.label') }}
          </elsa-input>
        </div>
        <div v-if="fromAdmin" class="form-row">
          <elsa-input
              v-if="!editMode"
              name="organizationOwner"
              :label="$t('organization_profile.edit_organization_modal.owner_field.label')"
              :placeholder="$t('organization_profile.edit_organization_modal.owner_field.placeholder')"
              v-model.lazy="form.organizationOwner"
            >
              {{ $t('organization_profile.edit_organization_modal.owner_field.label') }}
          </elsa-input>
          <elsa-select
            name="native_language"
            :label="$t('organization_profile.edit_organization_modal.nativelanguage_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.nativelanguage_field.placeholder')"
            :options="nativeLanguages"
            @change="onFormChange"
            filterable
            v-model.lazy="form.nativeLanguage"
          />
        </div>
        <div class="form-row">
          <elsa-select
            name="parent"
            :label="$t('organization_profile.edit_organization_modal.parent_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.parent_field.placeholder')"
            :options="allOrganization"
            @change="onFormChange"
            filterable
            v-model.lazy="form.parent"
          />
          <elsa-select
            name="product_type"
            :label="$t('organization_profile.edit_organization_modal.purchasedproduct_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.purchasedproduct_field.placeholder')"
            :options="purchasedProductTypes"
            @change="onFormChange"
            filterable
            multiple
            v-model.lazy="form.purchased_products"
          />
        </div>
        <div class="form-row" v-if="form.orgType != 'k12'">
          <country-select
            name="country_content_restrict"
            :label="$t('organization_profile.edit_organization_modal.countries_content_restrict_field.label')"
            :placeholder="$t('organization_profile.edit_organization_modal.countries_content_restrict_field.placeholder')"
            v-model="form.countryContentRes"
            filterable
            clearable
            @change="onFormChange"
          />
        </div>
        <div class="form-row" v-show="false">
          <el-form-item>
            <el-switch
                v-model="form.isNova"
                active-text="Is Nova"
            />
          </el-form-item>
        </div>
        <div v-if="fromAdmin" class="form-row">
          <el-checkbox
            class="elsa-checkbox"
            label="verified"
            name="verified"
            v-model.lazy="form.verified"
          >
            {{ $t('organization_profile.edit_organization_modal.verified_organization') }}
          </el-checkbox>
          <el-checkbox
            class="elsa-checkbox"
            label="use-dummy-email"
            name="useDummyEmail"
            v-model.lazy="form.useDummyEmail"
          >
            {{ $t('organization_profile.edit_organization_modal.use_dummy_email') }}
          </el-checkbox>
          <el-checkbox
            class="elsa-checkbox"
            label="use-custom-assessment"
            name="useCustomAssessment"
            v-model.lazy="form.useCustomAssessment"
          >
            {{ $t('organization_profile.edit_organization_modal.use_custom_assessment') }}
          </el-checkbox>
        </div>
      </el-form>
    </template>
    <template v-slot:footer>
      <div class="form-actions">
        <primary-button
          @click.native="submitForm"
          ref="submit"
          disabled
          v-loading.fullscreen.lock="loading"
        >
          {{ $t('organization_profile.edit_organization_modal.save') }}
        </primary-button>
        <tertiary-button @click.native="handleCancelClick">
          {{ $t('organization_profile.edit_organization_modal.cancel') }}
        </tertiary-button>
      </div>
      <div v-if="editMode && fromAdmin" class="org-actions">
        <div class="action" @click="disableOrganizationEvent">
          <i :class="isActive ? 'elsa-icon-off' : 'elsa-icon-on'"/>
          {{ isActive ? $t('organization_profile.edit_organization_modal.disable_organization') : $t('organization_profile.edit_organization_modal.enable_organization') }}
        </div>
        <!-- <div class="action" @click="deleteOrganizationEvent">
          <i class="elsa-icon-grey-delete"/>
          {{ $t('organization_profile.edit_organization_modal.delete_organization') }}
        </div> -->
      </div>
    </template>
  </modal>
</template>

<script>
  import axios from "@/utils/axios";
  import Modal from '@/components/common/Modal'
  import Upload from '@/components/common/Upload'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import ElsaInput from '@/components/common/Input'
  import ElsaSelect from '@/components/common/Select'
  import CountrySelect from '@/components/common/CountrySelect'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import ApiErrors from '@/components/common/ApiErrors'
  import { mapActions } from 'vuex'
  import { path, pathOr, map, either, isEmpty, isNil, contains, values, assoc, compose, toLower, sortBy, prop, reject, find, propEq, concat, converge, mergeAll, objOf, propOr, unless } from 'ramda'
  import { handleFormValidation, handleSubmitButtonState } from '@/helpers/formValidationHelper'
  import { industries } from '@/constants/industry'
  import { successMessage, warningMessage } from '@/utils/messages'
  import { ADMIN } from '../../../constants/userRoles'
  import { countries } from '@/helpers/countries'
  import timezones from '@/helpers/timezones'
  import { getNativeLanguages } from '@/helpers/languages'
  import { PRODUCT_TYPE_OPTIONS } from '@/constants/generic'

  export default {
    components: {
      Modal,
      PrimaryButton,
      TertiaryButton,
      // Upload,
      ElsaInput,
      ElsaSelect,
      CountrySelect,
      ApiErrors,
    },
    props: {
      editMode: {
        type: Boolean,
        default: false
      },
      fromAdmin: {
        type: Boolean,
        default: false
      },
      organization: {
        type: Object,
        default: () => {}
      },
    },
    computed: {
      isActive() {
        return this.organization.status === 'active'
      },
      industriesOptions() {
        const options = industries.map((industry) => {
          return {
            label: this.$t(`industries.${industry}`),
            value: industry
          }
        })
        return sortBy(compose(toLower, prop('label')))(options)
      },
      timezones() {
        return map(converge(mergeAll, [objOf('value'), objOf('label')]) ,timezones)
      },
      purchasedProductTypes() {
        return PRODUCT_TYPE_OPTIONS
      },
    },
    data() {
      return {
        errors: [],
        form: {
          name: path(['organization', 'name'])(this),
          code: path(['organization', 'code'])(this),
          // username: path(['organization', 'username'])(this),
          orgType: path(['organization', 'type'])(this),
          industry: path(['organization', 'industry'])(this),
          address1: path(['organization', 'address_1'])(this),
          address2: path(['organization', 'address_2'])(this),
          city: path(['organization', 'city'])(this),
          state: path(['organization', 'state'])(this),
          postcode: path(['organization', 'postal_code'])(this),
          country: path(['organization', 'country'])(this),
          phoneCode: path(['organization', 'phone'])(this) ? this.organization.phone.split(' ')[0] : null,
          phoneNumber: path(['organization', 'phone'])(this) ? this.organization.phone.split(' ')[1] : null,
          // affiliate: path(['organization', 'affiliate'])(this),
          verified: path(['organization', 'is_verified'])(this),
          organizationOwner: path(['organization', 'owner_user'])(this),
          image: path(['organization', 'logo_url'])(this),
          timezone: path(['organization', 'timezone'])(this),
          parent: path(['organization', 'parent'])(this),
          useDummyEmail: path(['organization', 'use_dummy_email'])(this),
          useCustomAssessment: path(['organization', 'has_custom_assessment_test'])(this),
          nativeLanguage: path(['organization', 'native_language'])(this),
          purchased_products: path(['organization', 'purchased_products'])(this),
          countryContentRes: path(['organization', 'country_content_restrict'])(this),
          isNova: path(['organization', 'is_nova'])(this),
        },
        value: '',
        rules: {
           name: { required: true, message: this.$t('organization_profile.edit_organization_modal.organization_validation'), trigger: 'blur' },
          //  username: { required: true, message: 'Please input username', trigger: 'blur' },
           orgType: { required: true, message: this.$t('organization_profile.edit_organization_modal._organization_type_validation'), trigger: 'blur' },
           industry: { required: true, message: this.$t('organization_profile.edit_organization_modal.industry_validation'), trigger: 'blur' },
           address1: { required: true, message: this.$t('organization_profile.edit_organization_modal.address_field.validation_msg'), trigger: 'blur' },
           phoneCode: { required: true, message: this.$t('organization_profile.edit_organization_modal.phone_field.validation_msg'), trigger: 'blur' },
           phone: { type: 'number', message: this.$t('organization_profile.edit_organization_modal.phone_field.validation_number_msg'), trigger: 'blur' },
           country: { required: true, message: this.$t('organization_profile.edit_organization_modal.country_field.validation_msg'), trigger: 'blur' },
           state: { required: true, message: this.$t('organization_profile.edit_organization_modal.state_field.validation_msg'), trigger: 'blur' },
           city: { required: true, message: this.$t('organization_profile.edit_organization_modal.city_field.validation_msg'), trigger: 'blur' },
           organizationOwner: [
             { required: !this.editMode, message: this.$t('organization_profile.edit_organization_modal.owner_field.required_validation_msg'), trigger: 'blur' },
             { type: 'email', message: this.$t('organization_profile.edit_organization_modal.owner_field.email_validation_msg'), trigger: 'blur' },
           ],
           postcode: [
             { required: true, message: this.$t('organization_profile.edit_organization_modal.post_code_field.validation_msg'), trigger: 'blur' }
           ]
        },
        loading: false,
        allOrganization: [],
        nativeLanguages: [],
      }
    },
    mounted () {
      this.onFormChange();
      this.getAllOrganizations();
      this.getNativeLanguages();
    },
    methods: {
      async submitRequest() {
        const organizationFormObject = {
          name: this.form.name,
          code: this.form.code,
          // username: this.form.username,
          industry: this.form.industry,
          type: this.form.orgType,
          address_1: this.form.address1,
          address_2: this.form.address2,
          city: this.form.city,
          state: this.form.state,
          postal_code: this.form.postcode,
          country: this.form.country,
          phone: `${this.form.phoneCode} ${this.form.phoneNumber}`,
          // affiliate: this.form.affiliate,
          verified: this.form.verified,
          status: pathOr('active', ['organization', 'status_id'])(this),
          logo_url: this.form.image || "",
          is_verified: this.form.verified,
          timezone: this.form.timezone,
          parent: this.form.parent,
          use_dummy_email: this.form.useDummyEmail,
          has_custom_assessment_test: this.form.useCustomAssessment,
          native_language: this.form.nativeLanguage,
          purchased_products: this.form.purchased_products,
          country_content_restrict: this.form.countryContentRes,
          is_nova: this.form.isNova,
        }

        const organizationObject = reject(either(isNil, isEmpty))(organizationFormObject)

        try {
          this.loading = true;
          const organizationOwner = path(['form', 'organizationOwner'])(this)
          const createOrganization = !this.organization
          const organization = this.organization ? await this.updateOrganization({ id: this.organization.id, organization: organizationObject })
            : await this.createOrganization(organizationObject)

          if(!this.editMode) {
            this.resetForm()
          }

          if(!this.fromAdmin) {
            this.$store.dispatch('organization/getCurrentOrganization')
          }

          this.$emit('closed')
          this.loading = false;
          if(this.fromAdmin && createOrganization && organizationOwner) {
            const organizationId = organization.id
            const emails = [ organizationOwner ]
            const role = ADMIN
            try {
              this.$store.dispatch('invite/inviteUsers', {
                emails,
                organizationId,
                role,
              })
            } catch {
              return warningMessage(this.$t('organization_profile.edit_organization_modal.invite_not_send'))(this)
            }
          }

          this.organization ? successMessage(this.$t('organization_profile.edit_organization_modal.update_success'))(this) : successMessage(this.$t('organization_profile.edit_organization_modal.create_success'))(this)

        } catch (error) {
          this.loading = false;
          this.errors = error
        }
      },
      submitForm() {
        handleFormValidation(this.$refs.form, this.submitRequest, () => { this.dialogVisible = true })
      },
      onFormChange() {
        let requiredFields = {
          name: this.form.name,
          // username: this.form.username,
          industry: this.form.industry,
          type: this.form.orgType,
          address_1: this.form.address1,
          city: this.form.city,
          state: this.form.state,
          postal_code: this.form.postcode,
          country: this.form.country,
          phoneCode: this.form.phoneCode,
          // phoneNumber: this.form.phoneNumber,
        }

        if(this.fromAdmin && !this.editMode) {
          requiredFields = assoc('owner_user', this.form.organizationOwner)(requiredFields)
        }

        const emptyFields = map(either(isNil, isEmpty), requiredFields)

        handleSubmitButtonState(this.$refs.submit.$el, !contains(true, values(emptyFields)))
      },
      handleCancelClick() {
        this.$emit('closed')
      },
      deleteOrganizationEvent() {
        this.$emit('closed', 'delete')
      },
      disableOrganizationEvent() {
        this.$emit('closed', 'disable')
      },
      handleAvatarUpload(base64Image) {
        this.form.image = base64Image
      },
      ...mapActions({
        updateOrganization: 'admin/updateOrganization',
        createOrganization: 'admin/createOrganization',
        deleteOrganization: 'admin/deleteOrganization'
      }),
      resetForm() {
        this.$refs.form.resetFields()
        handleSubmitButtonState(this.$refs.submit.$el, false)
        this.form = {}
      },
      getAllOrganizations() {
        let url = `v1/organizations/all-organizations`;
        axios.get(url).then((response) => {
          let organizations = response.data;
          this.allOrganization = organizations.map(org => {
            return {
              label: org.name,
              value: org.id
            }
          })
        })
      },
      async getNativeLanguages() {
        this.nativeLanguages = await getNativeLanguages()
      }
    },
    watch: {
      '$attrs.dialogVisible' () {
        if (this.editMode)
          this.form = {
            name: path(['name'])(this.organization),
            code: path(['code'])(this.organization),
            // username: path(['username'])(this.organization),
            orgType: path(['type'])(this.organization),
            industry: path(['industry'])(this.organization),
            address1: path(['address_1'])(this.organization),
            address2: path(['address_2'])(this.organization),
            city: path(['city'])(this.organization),
            state: path(['state'])(this.organization),
            postcode: path(['postal_code'])(this.organization),
            country: path(['country'])(this.organization),
            phoneCode: path(['phone'])(this.organization) ? this.organization.phone.split(' ')[0] : null,
            phoneNumber: path(['phone'])(this.organization) ? this.organization.phone.split(' ')[1] : null,
            // affiliate: path(['affiliate'])(this.organization),
            verified: path(['is_verified'])(this.organization),
            organizationOwner: path(['owner_user'])(this.organization),
            image: path(['logo_url'])(this.organization),
            timezone: path(['timezone'])(this.organization),
            useDummyEmail: path(['use_dummy_email'])(this.organization),
            useCustomAssessment: path(['has_custom_assessment_test'])(this.organization),
            nativeLanguage: path(['native_language'])(this.organization),
            purchased_products: path(['purchased_products'])(this.organizations),
            countryContentRes: path(['country_content_restrict'])(this.organization),
            isNova: path(['is_nova'])(this.organization),
          }

        this.$store.dispatch('organization/getOrganizationTypes')
      },
      'form.country': {
        immediate: true,
        deep: true,
        handler(newValue, oldValue) {
          if(newValue && newValue !== oldValue) {
            const phoneCode = compose(
              unless(isNil, concat('+')),
              propOr(null, 'dialCode'),
              find(propEq('iso2', newValue))
            )(countries)

            this.form = {
              ...this.form,
              phoneCode,
            }
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../scss/_colors.scss";
  ::v-deep .el-dialog.elsa-modal {
    .el-dialog__body > *:not(p) > div {
      padding-bottom: 20px;
    }
    .el-dialog__footer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .org-actions {
    margin-top: 60px;
    display: flex;
    .action {
      display: flex;
      font-weight: 600;
      font-size: 14px;
      margin-right: 30px;
      cursor: pointer;
      color: $dark-blue-2;
      align-items: center;
      i {
        margin-right: 7px;
        &::after {
          margin: 0;
          filter: invert(39%) sepia(4%) saturate(2648%) hue-rotate(157deg) brightness(93%) contrast(81%);
        }
      }
      &:hover {
       font-weight: 800;
      }
    }
  }
  .elsa-input.is-error[name="address"] {
    padding-bottom: 20px;
  }
  ::v-deep .el-switch__label * {
    color: #546873;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: initial;
    margin-bottom: 8px;
    opacity: 1;
    text-transform: none;
  }
</style>
